
import React, { useContext } from 'react';
import "./styles.scss";
import Seo from 'Components/Seo/Seo';
import DomainContext from 'Context/DomainContext';
import { useTranslation } from 'react-i18next';

function UpdatePage() {
    const { storeId } = useContext(DomainContext);
    const { t } = useTranslation();

    const storeName = storeId === 1 ? "Promofit" : "Expofit";


    return (
        <React.Fragment>
            <Seo robots="NOINDEX,NOFOLLOW" />
            <div className='container px-4 update_page no-translate notranslate'>
                <div className='py-4 pt-8 pt-xl-12'>
                    <h1 className='fs-32 fw-700 pt-4 pb-8'>
                        {t("title", { store: storeName })}
                    </h1>
                    <p className="fs-15 pb-4 line-6">{t("greeting")}</p>
                    <p className="fs-15 pb-4 line-6">{t("description", { store: storeName })}</p>
                </div>

                <div className='py-4'>
                    <h1 className="fs-20 fw-700 pb-2">{t("whatHappened")}</h1>
                    <p className="fs-15 pb-4 line-6">{t("whatHappenedDesc")}</p>
                </div>

                <div className='py-4'>
                    <h1 className="fs-20 fw-700 pb-2">{t("leakedData")}</h1>
                    <ul className='py-2'>
                    <li>{t("leakedData1")}</li>
                    <li>{t("leakedData2")}</li>
                    <li>{t("leakedData3")}</li>
                    <li>{t("leakedData4")}</li>
                    </ul>

                    <p className="fs-15 pb-4 line-6">{t("leakedDataDesc")}</p>
                </div>

                <div className='py-4'>
                    <h1 className="fs-20 fw-700 pb-2">{t("actionsTaken")}</h1>
                    <p className="fs-15 pb-4 line-6">{t("actionsTakenDesc")}</p>
                </div>

                <div className='py-4'>
                    <h1 className="fs-20 fw-700 pb-2">{t("recommendations")}</h1>
                    <p className="fs-15 pb-4 line-6">{t("recommendationsDesc")}</p>
                    <p className="fs-15 pb-4 line-6">{t("recommendationsDesc2")}</p>
                </div>

                <div className='py-4'>
                    <p className="fs-15 pb-2">{t("closing")}</p>
                    <p className="fs-15 pb-4">{t("team", { store: storeName })}</p>
                </div>
            </div>
        </React.Fragment>
    );
  }

  export default UpdatePage;